import {
    filter,
    map,
    pipe,
    sortBy,
    when
} from 'ramda';
import parseMethod from 'js/components/main/QuickDeposit/parseMethod';

import {
    getList,
    prepareAccounts,
    reformatMethodProps,
    addCommonFields,
    getSubMethods,
    mergeWithAccountFields,
    comparator,
    addSubMethods,
    filterParentMethods,
    extractVisaCheckoutCC,
    addPredefinedOptions,
    addVisaCheckoutPM,
    removeCCMethodsWithoutAccounts
} from 'js/components/main/QuickDeposit/parse';

export const filterAccounts = when(
    ({ accounts }) => Boolean(accounts),
    method => ({
        ...method,
        accounts: method.accounts
    })
);

export default options => (response) => {
    let [methods, accounts] = response.map(getList);
    methods = methods.map(reformatMethodProps);
    accounts = prepareAccounts(accounts);

    const VCOAccounts = [];
    const subMethods = {};

    return pipe(
        sortBy(comparator(options)),
        map(addCommonFields),
        map(getSubMethods({ ...options, subMethods })),
        addSubMethods({ subMethods }),
        filter(filterParentMethods({ ...options, subMethods })),
        map(mergeWithAccountFields(accounts)),
        map(filterAccounts),
        map(extractVisaCheckoutCC({ ...options, VCOAccounts })),
        addVisaCheckoutPM({ VCOAccounts }),
        filter(removeCCMethodsWithoutAccounts(options)),
        map(addPredefinedOptions),
        map(parseMethod(options))
    )(methods);
};
